import { render, staticRenderFns } from "./DashboardAssessmentCard.vue?vue&type=template&id=da556ecc&scoped=true"
import script from "./DashboardAssessmentCard.vue?vue&type=script&lang=ts"
export * from "./DashboardAssessmentCard.vue?vue&type=script&lang=ts"
import style0 from "./DashboardAssessmentCard.vue?vue&type=style&index=0&id=da556ecc&prod&scoped=true&lang=scss"
import style1 from "./DashboardAssessmentCard.vue?vue&type=style&index=1&id=da556ecc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da556ecc",
  null
  
)

export default component.exports